import React, { useContext, useState, useEffect } from "react";
import { auth, db } from "layouts/firebase.js";
//import { useStateValue } from "layouts/StateProvider.js";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  //const [{}, dispatch] = useStateValue();

  //const [rofuser, setRofuser] = useState();
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  function signup(email, password) {
    return auth.createUserWithEmailAndPassword(email, password);
  }

  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  function logout() {
    return auth.signOut();
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email);
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password);
  }

  useEffect(() => {
    //let roleofuser = "";
    // Lay role of user

    //const unsubscribe =
    auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      /* let roleofuser = "";
      db.collection("users")
        .doc(auth.currentUser?.uid)
        .collection("userprofile")
        //.doc()
        //.orderBy('created','desc')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(`${doc.id} => ${doc.data().userrole}`);
            roleofuser = `${doc.data().userrole}`;
          });
        })
        .then(() => {
          dispatch({
            type: "SET_ROLEOFUSER",
            roleofuser: roleofuser,
          });
          setRofuser(roleofuser);
          console.log(" Da lay dc roleofuser: ", roleofuser);
        }); */
      setLoading(false);
    });

    //return unsubscribe;
  }, []);

  const value = {
    currentUser,
    //rofuser,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
